<div fxLayout="row" fxLayout.lt-md="column">
  <mat-card *ngIf="renderer" [fxFlex.gt-sm]="50" fxFlex.gt-xs="100" fxFlex="100">
    <mat-card-content>
      <ul class="wrapper">
        <li class="form-row">
          <label>IP Address</label>
          <span>{{ renderer.ip }}</span>
        </li>
        <li class="form-row">
          <label>Hard Drive</label>
          <span>{{ ((renderer.hardDriveUsed) * 1e-9).toFixed(2) || "?" }}GB /
            {{ (renderer.hardDriveCapacity * 1e-9).toFixed(2) || "?" }}GB</span>
        </li>
        <li class="form-row">
          <label>GPU</label>
          <span>{{ renderer.gpu || "Unknown"}}</span>
        </li>
        <li class="form-row">
          <label>Launcher Version</label>
          <span>{{ renderer.launcherVersion || "Unknown"}}</span>
        </li>
        <li class="form-row">
          <label>Launcher Environment</label>
          <span>{{ renderer.launcherEnvironment || "Unknown"}}</span>
        </li>
        <li class="form-row">
          <label>Last Health Check</label>
          <span>{{ renderer.dateLastHealthCheck | date:'short' }}</span>
        </li>
        <li class="form-row">
          <label>Queue Check Interval (Milliseconds)</label>
          <span>{{ renderer.queueCheckIntervalInMilliseconds }}</span>
        </li>
      </ul>
    </mat-card-content>
  </mat-card>

  <div *ngIf="renderer" fxFlex.gt-sm="50" fxFlex.gt-xs="100" fxFlex="100">
    <mat-card>
      <mat-card-content>
        <div class="mat-card-content-label" fxLayoutAlign="space-between center" fxLayout="row" fxLayoutGap="0px"
          fxLayoutGap.lt-sm="15px" fxLayout.lt-sm="column">
          <label>Queues</label>
          <button *ngIf="admin" [@cardAnimator]="animateAddQueue" (@cardAnimator.done)="resetAddQueueAnimationState()"
            [matTooltip]="(renderer.rendererQueues?.length > 0 ? 'Add Queue' : 'Add Queue to get started!')"
            mat-flat-button color="accent" (click)="onClickAddQueue()">
            <mat-icon>add</mat-icon> Add Queue
          </button>
        </div>

        <mat-card *ngIf="renderer.rendererQueues?.length > 0" class="contrast"
          [ngClass.lt-lg]="{'mat-card-inline-sm': true}">
          <mat-card-content fxLayoutAlign="center center" fxLayout="row" fxLayout.lt-sm="column">
            <mat-form-field>
              <input matInput type="text" [formControl]="searchField" (keyup)="doFilterQueues($event.target.value)"
                (keyup.esc)="$event.target.value=''; doFilterQueues('')" placeholder="Filter queues by name">
            </mat-form-field>
          </mat-card-content>
        </mat-card>

        <div class="progress-container">
          <mat-progress-bar *ngIf="loadingQueues" mode="indeterminate" color="accent"></mat-progress-bar>
        </div>

        <div cdkDropList (cdkDropListDropped)="drop($event)" class="queue-list drag-drop-list" multi="false">
          <ng-container *ngFor="let item of filteredQueues; let i = index">
            <mat-card cdkDrag *ngIf="expandedQueuesList || i < 12" class="contrast card-link"
              [ngClass.lt-lg]="{'mat-card-inline-sm': true}" (click)="navigateToQueue(item?.queueId)">
              <mat-card-content class="drag-drop-item" fxLayoutAlign="center center" fxLayout="row"
                fxLayout.lt-sm="column">
                <div class="drop-placeholder" *cdkDragPlaceholder></div>
                <div fxFlex="55" fxLayoutAlign="start center" fxLayout="row">
                  <strong class="text-center" [ngClass.lt-sm]="{'card-title': true}"
                    [innerHtml]="item?.queueName | highlight: searchField.value"></strong>
                </div>

                <div fxFlex="30" fxLayoutAlign="end center" fxLayout="row" fxLayout.lt-sm="column" fxLayoutGap="0px"
                  fxLayoutGap.lt-sm="18px">
                  <p><small>Priority</small></p>
                  <div class="text-center" [ngClass.gt-xs]="{'m-l-5': true}">{{ item.priority }}</div>
                </div>

                <div fxFlex="15" fxLayoutAlign="end center" fxLayout="row" fxLayoutGap="10px">
                  <button mat-mini-fab [color]="item.enabled ? 'accent' : 'basic'"
                    [aria-label]="item.enabled ? 'Disable Queue' : 'Enable Queue'"
                    [matTooltip]="item.enabled ? 'Disable Queue' : 'Enable Queue'" (click)="toggleQueueEnabled(item)"
                    [class.button-spinner]="loading" [disabled]="">
                    <mat-icon>{{ (item.enabled ? 'toggle_on' : 'toggle_off') }}</mat-icon>
                  </button>
                </div>
              </mat-card-content>
            </mat-card>
          </ng-container>
        </div>
        <mat-card *ngIf="renderer.rendererQueues?.length > 0" class="contrast card-link banner-info"
          [ngClass.lt-lg]="{'mat-card-inline-sm': true}" (click)="toggleExpandedQueuesList()">
          <mat-card-content fxLayoutAlign="center center" fxLayout="row" fxLayout.lt-sm="column">
            <div fxFlex="100" fxLayoutAlign="center center" fxLayout="row">
              <strong *ngIf="!expandedQueuesList" class="text-center"
                [ngClass.lt-sm]="{'card-title': true}"><mat-icon>expand_more</mat-icon></strong>
              <strong *ngIf="expandedQueuesList" class="text-center"
                [ngClass.lt-sm]="{'card-title': true}"><mat-icon>expand_less</mat-icon></strong>
            </div>
          </mat-card-content>
        </mat-card>
      </mat-card-content>
    </mat-card>
  </div>
</div>
<div fxLayout="row" fxLayout.lt-md="column">
  <div *ngIf="renderer" fxFlex.gt-sm="100" fxFlex.gt-xs="100" fxFlex="100">
    <mat-card>
      <mat-card-content>
        <div class="mat-card-content-label" fxLayoutAlign="space-between center" fxLayout="row" fxLayoutGap="0px"
          fxLayoutGap.lt-sm="15px" fxLayout.lt-sm="column">
          <label>Jobs from last 24hrs</label>
        </div>

        <mat-card class="banner-error" *ngIf="(!filteredRecipes?.length)">
          <mat-card-content>
            No jobs found.
          </mat-card-content>
        </mat-card>

        <div class="recipe-list" multi="false">
          <recipe-event-summary-card *ngFor="let item of filteredRecipes"
            [recipeEventSummary]="item"
            [searchTerm]="searchTerm">
          </recipe-event-summary-card>
        </div>
        <mat-card *ngIf="renderer.rendererRecipes?.length > 0" class="contrast card-link banner-info"
          [ngClass.lt-lg]="{'mat-card-inline-sm': true}" (click)="toggleExpandedRecipesList()">
          <mat-card-content fxLayoutAlign="center center" fxLayout="row" fxLayout.lt-sm="column">
            <div fxFlex="100" fxLayoutAlign="center center" fxLayout="row">
              <strong *ngIf="!expandedRecipesList" class="text-center"
                [ngClass.lt-sm]="{'card-title': true}"><mat-icon>expand_more</mat-icon></strong>
              <strong *ngIf="expandedRecipesList" class="text-center"
                [ngClass.lt-sm]="{'card-title': true}"><mat-icon>expand_less</mat-icon></strong>
            </div>
          </mat-card-content>
        </mat-card>
      </mat-card-content>
    </mat-card>
  </div>
</div>